import React from "react";
import styles from "./Privacy.module.css";

const Privacy = () => {
  const currentDate = new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className={styles.privacyContainer}>
      <h1 className={styles.heading}>Privacy Policy</h1>
      <p className={styles.date}>Last updated: {currentDate}</p>

      <p>
        Welcome to <strong>ImageResizerAndCompressor</strong>, your preferred
        web tool for effortlessly and securely resizing and compressing images.
        Your privacy is very important to us. This Privacy Policy explains what
        information we collect, how we use it, and the safeguards we have in
        place to protect your information.
      </p>

      <h2>1. Personal Information We Do Not Collect</h2>
      <p>
        We respect your privacy and do not collect or store personal information
        like your name, email, or payment information. Any image you upload is
        processed directly in your browser and is never stored on our servers.
        Our tools are entirely anonymous.
      </p>

      <h2>2. Non-Personal Information We May Collect</h2>
      <p>
        To improve performance of the website and improve the user experience,
        we may collect anonymous, non-personal information such as your browser
        type, type of device, operating system and general location (country or
        region). This helps us improve the user experience and improve potential
        issues.
      </p>

      <h2>3. Cookies and Local Storage</h2>
      <p>
        We may use cookies and browser local storage to ensure our tools work
        smoothly and remember user preferences, such as theme or settings.
        Cookies may also be used for anonymous analytics and ad personalization
        through Google AdSense. You may disable cookies at any time in your
        browser settings.
      </p>

      <h2>4. Google AdSense and Advertising</h2>
      <p>
        Advertising on our site is powered by <strong>Google AdSense</strong>.
        Google may use cookies and other technologies to deliver ads based your
        browsing history, among other things. Please click on{" "}
        <a
          href="https://policies.google.com/technologies/ads"
          target="_blank"
          rel="noopener noreferrer"
        >
          Google Advertising Policies
        </a>{" "}
        to learn about Google's practices, or visit{" "}
        <a
          href="https://www.google.com/settings/ads"
          target="_blank"
          rel="noopener noreferrer"
        >
          Google Ads Settings
        </a>{" "}
        to opt out of personalized advertising.
      </p>

      <h2>5. Third-Party Analytics and Tools</h2>
      <p>
        We may use third-party services, such as Google Analytics, to better
        understand user engagement with our site. Third-party services may
        collect technical information such as your IP address and/or user-agent.
        All data collected will be used in accordance with the privacy policies
        of those third parties.
      </p>

      <h2>6. Data Security</h2>
      <p>
        We take reasonable safeguards to protect information processed through
        our website. However, we cannot guarantee that information transmitted
        over the Internet is totally secure.
      </p>

      <h2>7. Links to Other Websites</h2>
      <p>
        We may have links to external websites on our website. We are not
        responsible for external and third-party website privacy policies or
        content. It is recommended you consult their privacy policies before
        interacting with them.
      </p>

      <h2>8. Updates to this Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time to reflect changes
        to our policies and/or applicable laws, as needed. Any updates to our
        Privacy Policy will be posted here, with a new "Last updated" date shown
        below.
      </p>

      <h2>9. Contact Us</h2>
      <p>
        If you have any questions, suggestions, or concerns about this Privacy
        Policy, you can contact us at:{" "}
        <strong>your-imageimagecompressor123@gmail.com</strong>.
      </p>
    </div>
  );
};

export default Privacy;
